<template>
  <div
    id="sideToolsBox"
    class="sideToolsBox"
  >
    <div class="box">
      <div
        id="backTopBtn"
        class="inner showBackTop"
        @click="backTop"
      >
        <dl>
          <dd>
            <v-img
              class="images"
              src="../assets/images/details_icon_Stick.png"
            ></v-img>
          </dd>
          <dt>返回<br>
            顶部</dt>
        </dl>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    backTop(e) {
      e.stopPropagation();
      e.preventDefault();
      document.getElementById("apps").scrollTop = 0;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../pages/base.scss";

.sideToolsBox.hideTools {
  opacity: 0;
}
.sideToolsBox {
  transition: all 200ms;
}
.box {
  width: vw(60px);
  // height: vh(258px);
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 30px 0px rgba(236, 241, 248, 1);
  border-radius: 10px;
  text-align: center;
  font-size: fz(12px);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(137, 146, 154, 1);
  line-height: vh(16px);
  padding: 0 vw(9px);
}
.box .inner {
  height: vh(89px);
  cursor: pointer;
  padding: vh(15px) 0px;
  border-bottom: 1px solid rgba(245, 245, 245, 1);
}
.box .inner.showBackTop {
  display: none;
}
.box .inner:hover {
  color: green;
}
.box .inner .images {
  width: vw(24px);
  height: vh(24px);
  margin: 0 auto;
  margin-bottom: vh(8px);
}
</style>

